import authReducers from './auth/authReducers';
import languageReducers from './language/languageReducers';

const rootReducerConfig = [
  {
    name: 'auth',
    reducers: authReducers,
  },
  {
    name: 'language',
    reducers: languageReducers,
  },
];

export default rootReducerConfig;
